export default "__VITE_ASSET__bc724e0c__"